import { render, staticRenderFns } from "./ServiceFormList.vue?vue&type=template&id=34dedb78&scoped=true&"
import script from "./ServiceFormList.vue?vue&type=script&lang=js&"
export * from "./ServiceFormList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceFormList.vue?vue&type=style&index=0&id=34dedb78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dedb78",
  null
  
)

export default component.exports